<template>

  <Breadcrumbs main="Charger Anomaly" title="default" />

  <filter-s8
    @filterHandle="filterHandle"
    />

  <div class="container-fluid p-0">
    <div class="row widget-grid">
      <el-row class="m-0 width-100-p">
        <!-- Abatement -->
        <el-col class="d-flex align-item-center" :span="24">
            <el-col :span="24">
              <!-- <showMap /> -->
            </el-col>
        </el-col>
      </el-row>

      <el-row class="m-0 width-100-p">
        <!-- Abatement -->
        <el-col class="d-flex align-item-center" :span="24">
            <el-col :span="24">
              <groupByDistance 
                :mapDataProp="mapData"
                :findInMapProp="findInMap"
              />
            </el-col>
        </el-col>
      </el-row>

      <el-row class="m-0 width-100-p mt-3">
        <el-col :class="$vuetify.display.width > 700 ? 'd-flex align-item-center px-2' : 'd-flex align-item-center px-0'" :span="24">
          <div :class="$vuetify.display.width > 700 ? 'row m-0 width-100-p px-2' : 'row m-0 width-100-p px-0'">
            <div
              class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
            >
            <el-col :span="24" class="d-flex justify-content-between align-items-center flex-wrap mb-10">
              <h5 class="moderat-white-bold mb-0">Group of sites by {{ groupByDistance_m }} m distance</h5>
              <span class="moderat-white">
                {{ total_items.toLocaleString() }} {{ total_items === 1 ? "result" : "results" }}
              </span>
            </el-col>
              <el-row :gutter="$vuetify.display.width > 1200 ? 20 : 0">
                <!-- search bay -->
                <el-col
                      :span="$vuetify.display.width > 1200 ? 16 : 24"
                      :class="$vuetify.display.width > 1200 ? 'x-start order-1 mb-10' : 'x-start order-3 mb-10'"
                    >
                      <div class="d-flex align-items-center width-100-p flex-wrap">
                      <el-radio-group
                        v-model="includedFilter"
                        text-color="#ffff"
                        fill="#234B49"
                        class="included-filter-switch"
                        :class="$vuetify.display.width > 1200 ? 'mr-3' : 'mb-2'"
                      >
                        <el-radio-button
                          class="start-period all-group-by text-center"
                          label="all"
                        >
                          All
                        </el-radio-button>
                        <el-radio-button
                          class="site-group-by text-center"
                          label="included"
                        >
                          Included
                        </el-radio-button>
                        <el-radio-button
                          class="site-group-by text-center end-period"
                          label="not_included"
                        >
                          Not included
                        </el-radio-button>
                      </el-radio-group>
                      <div class="flex-grow-1" style="min-width: 0;">
                      <el-input
                        size="large"
                        v-model="search"
                          :placeholder="selectedSearchBy != '' ? 'Search by ' + (convertLabel(selectedSearchBy)) : 'Choose a search by options' "
                          :prefix-icon="Search"
                          class="mixedSearchBar"
                          id="mixedSearchBar-input"
                          clearable
                          @clear="handleClearSearch"
                          @keyup.enter="handleSearch"
                      >
                        <template #prepend>

                          <!-- search_by select -->
                          <el-tooltip
                            effect="light"
                            placement="top"
                            show-after="500"
                            hide-after="300"
                            >
                            <template #content > 
                                <span :style="{fontSize: '12px', textAlign: 'left'}"> {{ "Select Search by" }} </span>
                            </template>

                            <el-select
                              v-model="selectedSearchBy"
                              placeholder="Select"
                              style="min-width: 180px; height: 40px;"
                              @change="handleSelectSearchBy"
                              class="mixedSearchBar-select"
                            >
                              <!-- <template #label>
                                <span>Search by: </span>
                                <span style="font-weight: bold">{{ convertLabel(searchBytabs) }}</span>
                              </template> -->
                              <el-option
                                v-for="(item, index) in search_by_dropdown[selectedTableTab]"
                                :key="index"
                                :label="convertLabel(item)"
                                :value="item"
                              />
                            </el-select>
                          </el-tooltip>
                        </template>
                        
                        <template #append>
                          <!-- <el-button :icon="Search" /> -->
                          <el-button
                              @click.stop="handleSearch"
                              class="newSearchButtonClass"
                            >
                            <svg v-if="$vuetify.display.width > 800" class="width-115 height-40">
                              <use
                                href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon"
                              ></use>
                            </svg>
                            <svg v-else class="width-59 height-40" >
                              <use
                                href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon-small"
                              ></use>
                            </svg>
                          </el-button>
                        </template>
                      </el-input>
                      </div>
                    </div>

                </el-col>

                <!-- export button -->
                <el-col
                      :class="$vuetify.display.width > 1200 ? 'd-flex justify-content-end order-2' : 'd-flex justify-content-end order-1 mb-20'"
                      :span="$vuetify.display.width > 1200 ? 8 : 24"
                    >
                      <el-button
                        @click.stop="handleExportFile"
                        class="new-download-file-btn new-button-behavior x-end"
                      >
                          <svg class="width-40 height-40">
                            <use href="@/assets/svg/newSvgIcon.svg#newDownloadFileIcon"></use>
                          </svg>
                      </el-button>
                </el-col>
              </el-row>


              <tableGroupByDistance
                :loadingProp="loading"
                :usersDataProp="mapData"
                :totalRowProp="total_items"
                :includedFilterProp="includedFilter"
                @tableAction="handleTableAction"
              />
            </div>
          </div>
        </el-col>
      </el-row>
    </div>


  </div>

</template>

<script>
import { createLoadingInstance, convertToTitleCase, shorterLabel, convertTimezone } from "../common/common-tools";
import filterS8 from "../common/filter-s8.vue";
import UserService from '@/services/user.service';
// import showMap from './showMap.vue';
import groupByDistance from './MapGroupByDistance.vue';
import tableGroupByDistance from './tableGroupByDistance.vue';
// import { ElMessageBox } from "element-plus";

import { exportGroupSitesByDistanceExcel } from "../common/exportExcel";

export default {
    props: {},
    components: {
        // showMap,
        filterS8,
        groupByDistance,
        tableGroupByDistance,
    },
    computed: {
      stateList() {
        return this.states;
      },
      mapData() {
        return this.filterMapData(this.allMapData);
      },
      total_items() {
        return this.mapData.length;
      },
    },
    data() {
      return {
        filter_user: [],
        loading: false,
        current_page: 1,
        perPageCount: 10,

        filter: {
          customer_id: [],
          excluding_customer_ids: [],
          elec_region: "",
          country: "",
        },

        search_by_dropdown: {
        charging_sites: [
          'site_name',
          'customer',
          'group_id',
          'postcode',
          'elec_region',
          'charger_name',
          'charger_id',
          'year_added',
          'decommissioning_date',
          'active_until',
          'change_details',
          'change_date',
        ],
        },
        selectedSearchBy: 'site_name',
        search: '',
        appliedSearchBy: 'site_name',
        appliedSearch: '',
        includedFilter: 'all',
        selectedTableTab: 'charging_sites',

        allMapData: [],
        groupByDistance_m: '100',
        findInMap: [null, null],
      }
    },
    methods: {
      filterHandle(event) {
        // console.log("filterHandle", event);
        
        this.filter = event;
        this.fetchGroupByDistance();
      },

      convertShorterLabel(label, setLength, setMinLength, addOnLabel="") {
      return shorterLabel(label, setLength, setMinLength, addOnLabel);
    },

    convertLabel(str) {
      if (str === "group_id") {
        return "Motion Site ID";
      }
      if (str === "charger_id") {
        return "Motion Charger ID";
      }
      return convertToTitleCase(str);
    },

    getGroupSites(item) {
      const centralSite = item?.central_site || {};
      const nearbySites = Array.isArray(item?.nearby_sites) ? item.nearby_sites : [];
      return [centralSite, ...nearbySites];
    },

    getGroupChargers(item) {
      return this.getGroupSites(item).flatMap((site) =>
        Array.isArray(site.chargers) ? site.chargers : []
      );
    },

    collectSearchValues(values) {
      return values.filter((value) => value != null && String(value).trim() !== "");
    },

    expandSearchText(value) {
      if (value == null || String(value).trim() === "") {
        return [];
      }
      const text = String(value);
      const spaced = text.replaceAll("_", " ");
      return text === spaced ? [text] : [text, spaced];
    },

    expandSearchDate(value) {
      if (value == null || String(value).trim() === "") {
        return [];
      }
      const raw = String(value).trim();
      const values = [raw];
      try {
        const formatted = convertTimezone(raw, "date");
        if (formatted && !String(formatted).toLowerCase().includes("invalid")) {
          values.push(formatted);
        }
      } catch {
        // keep the raw value only
      }
      return values;
    },

    isChargerIncluded(charger) {
      return charger?.is_included === true
        || String(charger?.is_included).toUpperCase() === "TRUE"
        || String(charger?.is_included).toUpperCase() === "YES";
    },

    isChargerNotIncluded(charger) {
      return charger?.is_included === false
        || String(charger?.is_included).toUpperCase() === "FALSE"
        || String(charger?.is_included).toUpperCase() === "NO";
    },

    chargerMatchesIncludedFilter(charger) {
      if (this.includedFilter === "included") {
        return this.isChargerIncluded(charger);
      }
      if (this.includedFilter === "not_included") {
        return this.isChargerNotIncluded(charger);
      }
      return true;
    },

    groupMatchesIncludedFilter(item) {
      if (this.includedFilter === "all") {
        return true;
      }
      return this.getGroupChargers(item).some((charger) => this.chargerMatchesIncludedFilter(charger));
    },

    getSearchFieldValues(item, searchBy) {
      const sites = this.getGroupSites(item);
      const chargers = this.getGroupChargers(item);

      if (searchBy === "group_id") {
        return this.collectSearchValues([item?.group_id]);
      }
      if (searchBy === "site_name") {
        return this.collectSearchValues(sites.flatMap((site) => this.expandSearchText(site.site_name)));
      }
      if (searchBy === "customer") {
        return this.collectSearchValues(sites.flatMap((site) => this.expandSearchText(site.full_name)));
      }
      if (searchBy === "postcode") {
        return this.collectSearchValues(sites.map((site) => site.postcode));
      }
      if (searchBy === "elec_region") {
        return this.collectSearchValues(sites.flatMap((site) => this.expandSearchText(site.elec_region)));
      }
      if (searchBy === "charger_name") {
        return this.collectSearchValues(chargers.map((charger) => charger.charger_name));
      }
      if (searchBy === "charger_id") {
        return this.collectSearchValues(chargers.map((charger) => charger.id));
      }
      if (searchBy === "year_added") {
        return this.collectSearchValues(chargers.map((charger) => charger.year_added));
      }
      if (searchBy === "decommissioning_date") {
        return this.collectSearchValues(chargers.flatMap((charger) => this.expandSearchDate(charger.decommissioning_date)));
      }
      if (searchBy === "active_until") {
        return this.collectSearchValues(chargers.flatMap((charger) => this.expandSearchDate(charger.active_until)));
      }
      if (searchBy === "change_details") {
        return this.collectSearchValues(chargers.map((charger) => charger.change_details));
      }
      if (searchBy === "change_date") {
        return this.collectSearchValues(chargers.flatMap((charger) => this.expandSearchDate(charger.change_date)));
      }
      return [];
    },

    filterMapData(data) {
      if (!Array.isArray(data)) {
        return [];
      }
      const query = String(this.appliedSearch || "").trim().toLowerCase();
      const searchBy = this.appliedSearchBy;
      return data.filter((item) => {
        if (this.includedFilter !== "all" && !this.groupMatchesIncludedFilter(item)) {
          return false;
        }
        if (!query) {
          return true;
        }
        const values = this.getSearchFieldValues(item, searchBy);
        return values.some((value) => value != null && String(value).toLowerCase().includes(query));
      });
    },

    handleTableAction(action) {
      if (action.kind == 'findInMap') {
      // console.log('action', action);
      //   console.log('lat', action.data.lat);
      //   console.log('lng', action.data.lng);
        this.findInMap = [action.data.lat, action.data.lng];
      }
    },

    formatExportDate(value) {
      if (value == null || String(value).trim() === "") {
        return "";
      }
      try {
        const formatted = convertTimezone(String(value).trim(), "date");
        if (!formatted || String(formatted).toLowerCase().includes("invalid")) {
          return String(value).trim();
        }
        return formatted;
      } catch {
        return String(value).trim();
      }
    },

    formatExportIncluded(value) {
      if (value === true || String(value).toUpperCase() === "TRUE" || String(value).toUpperCase() === "YES") {
        return "Yes";
      }
      if (value === false || String(value).toUpperCase() === "FALSE" || String(value).toUpperCase() === "NO") {
        return "No";
      }
      return "";
    },

    processDataForExport(data) {
      let processedData = [];
      data.forEach(item => {
        processedData.push({
          "Motion Site ID": item.group_id,
          "site_name": item.central_site.site_name,
          "postcode": item.central_site.postcode,
          "customer": item.central_site.full_name,
          "state": item.central_site.state,
          "elec_region": item.central_site.elec_region,
          "address_comment": item.central_site.address_comment,
          "lat": item.central_site.lat,
          "lng": item.central_site.lng,
          "group_size": item.total_sites_in_group,
          "distance_m": "Central Site",
        });
        
        if (item.nearby_sites) {
          item.nearby_sites.forEach(site => {
            processedData.push({
              "Motion Site ID": item.group_id,
              "site_name": site.site_name,
              "postcode": site.postcode,
              "customer": site.full_name,
              "state": site.state,
              "elec_region": site.elec_region,
              "address_comment": site.address_comment,
              "lat": site.lat,
              "lng": site.lng,
              "group_size": "-",
              "distance_m": site.distance_m,
            });
          });
        }
      });
      return processedData;
    },

    processChargerDataForExport(data) {
      const processedData = [];
      const groups = Array.isArray(data) ? data : [];

      groups.forEach((item) => {
        const appendSiteChargers = (site, siteRole, distanceM) => {
          const chargers = Array.isArray(site?.chargers) ? site.chargers : [];
          chargers.forEach((charger) => {
            if (!this.chargerMatchesIncludedFilter(charger)) {
              return;
            }
            processedData.push({
              "Motion Site ID": item.group_id,
              site_name: site.site_name,
              postcode: site.postcode,
              customer: site.full_name,
              state: site.state,
              elec_region: site.elec_region,
              site_role: siteRole,
              distance_m: distanceM,
              "Motion Charger ID": charger.id,
              charger_name: charger.charger_name,
              year_added: charger.year_added,
              decommissioning_date: this.formatExportDate(charger.decommissioning_date),
              active_until: this.formatExportDate(charger.active_until),
              included: this.formatExportIncluded(charger.is_included),
              change_details: charger.change_details,
              change_date: this.formatExportDate(charger.change_date),
            });
          });
        };

        appendSiteChargers(item.central_site, "Central Site", "Central Site");
        (item.nearby_sites || []).forEach((site) => {
          appendSiteChargers(site, "Nearby", site.distance_m);
        });
      });

      return processedData;
    },

    async handleExportFile() {
      const dataList = this.processDataForExport(this.mapData);
      const chargerDataList = this.processChargerDataForExport(this.mapData);
      const skipKeys = [];
      const fileName = "DuplicateSitesReport.xlsx";
      const newWorksheetName = "DuplicateSitesReport";
      const title = `Group Sites By Distance ${this.groupByDistance_m} m`;

      try {
            await exportGroupSitesByDistanceExcel({
                dataList,
                chargerDataList,
                skipKeys,
                fileName,
                newWorksheetName,
                title,
                });
                console.log("Excel file generated successfully!");
          } catch (error) {
              console.error("Error generating Excel file:", error);
          }
      },

    handleSearch() {
      this.appliedSearch = this.search;
      this.appliedSearchBy = this.selectedSearchBy;
    },

    handleClearSearch() {
      this.search = '';
      this.appliedSearch = '';
    },

    handleSelectSearchBy(search_by){
      this.selectedSearchBy = search_by;
    },

    normalizeCustomerIds(customer_id) {
      if (customer_id == null || customer_id === "") {
        return [];
      }
      const ids = Array.isArray(customer_id) ? customer_id : [customer_id];
      return ids
        .map((id) => Number(id))
        .filter((id) => Number.isInteger(id) && !Number.isNaN(id));
    },

    fetchGroupByDistance({ userInitiated = false } = {}) {
        const customerIds = this.normalizeCustomerIds(this.filter.customer_id);
        if (customerIds.length === 0) {
          this.allMapData = [];
          if (userInitiated) {
            this.$message.error("Please select at least one customer.");
          }
          return;
        }

        const loading = createLoadingInstance();
        this.loading = true;
        const excludingCustomerIds = this.normalizeCustomerIds(this.filter.excluding_customer_ids);
        UserService.ChargerMapGroupByDistance(this.filter.distance, customerIds, this.filter.elec_region, this.filter.country, excludingCustomerIds)
          .then(
            (response) => {
              if(!response.data){
                this.allMapData = [];
                this.loading = false;
                loading.close();
                return;
              }
              // console.log("map data", response.data);
              
              // Handle the response structure: response.data.data contains the array
              if (response.data && response.data.data && Array.isArray(response.data.data)) {
                this.allMapData = response.data.data;
                this.groupByDistance_m = response.data.group_by_distance_m;
              } else if (Array.isArray(response.data)) {
                this.allMapData = response.data;
                this.groupByDistance_m = response.group_by_distance_m;
              } else {
                this.allMapData = [];
                console.warn("Expected array data but received:", typeof response.data);
              }
              this.loading = false;
              loading.close();
            },
            (error) => {
              this.loading = false;
              loading.close();
              console.log(error);
              const status = error.response?.status;
              if (status == 401) {
                this.$router.push({
                  path: "/",
                  query: {
                    error: "Unauthorized",
                  },
                });
              } else if (status == 400) {
                this.$message.error(error.response?.data?.message || "customer_id is required.");
              }
              return;
            }
          )
          .catch((error) => {
            this.loading = false;
            loading.close();
            console.log(error);
            const status = error.response?.status;
            if (status == 401) {
              this.$router.push({
                path: "/",
              });
              return;
            }
            if (status == 400) {
              this.$message.error(error.response?.data?.message || "customer_id is required.");
            }
          })
          .finally(() => {
            this.loading = false;
            loading.close();
          });
      },
  },
};
</script>

<style scoped>
.included-filter-switch {
  flex-shrink: 0;
}
</style>